<template>
    <div class="modal fade" :id="modalId" data-bs-backdrop="static" aria-labelledby="segment-refine-modal-title" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header border-bottom-0 pb-0">
                    <h3 class="modal-title" id="segment-refine-modal-title">Refine Audience</h3>
                    <button type="button" class="btn btn-white close-modal" data-bs-dismiss="modal" aria-label="Close" @click="handleClose">
                        <img class="icon me-0" src="/img/icons/avid-icons/close.svg" alt="">
                    </button>
                </div>
                <div class="modal-body">
                    <p class="mb-3">How would you like to change this audience?</p>
                    <textarea
                        id="segment-refine-context"
                        v-model="userContext"
                        class="form-control"
                        rows="4"
                        placeholder="E.g., Add donors who gave in the last year; Exclude contacts who haven't opened an email..."
                    ></textarea>
                </div>
                <div class="modal-footer pt-1">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="handleClose">Cancel</button>
                    <button type="button" class="btn btn-primary" @click="submit" :disabled="submitting || !userContext.trim()">
                        <span v-if="submitting" class="spinner-border spinner-border-sm me-1" role="status"></span>
                        <img v-else class="icon me-1" src="/img/icons/avid-icons/edna.svg" alt="">
                        Refine
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'SegmentRefineModal',
    props: {
        client: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            modalId: 'segment-refine-modal-' + Date.now(),
            userContext: '',
            submitting: false,
            currentSegment: null,
        };
    },
    methods: {
        show(segment) {
            this.currentSegment = segment;
            this.userContext = '';
            const modalEl = document.getElementById(this.modalId);
            if (modalEl && window.bootstrap) {
                let modal = window.bootstrap.Modal.getInstance(modalEl);
                if (!modal) modal = new window.bootstrap.Modal(modalEl);
                modal.show();
            }
        },
        submit() {
            if (!this.userContext.trim() || this.submitting || !this.currentSegment) return;
            this.submitting = true;
            window.axios
                .post(`/api/segment-suggestion/${this.client.url}/refine`, {
                    user_context: this.userContext.trim(),
                    current_filter: this.currentSegment.filter,
                    data_blend_id: this.currentSegment.data_source_id,
                })
                .then((response) => {
                    const segmentSuggestionId = response.data.segment_suggestion_id;
                    this.$emit('refine-submitted', { segment_suggestion_id: segmentSuggestionId });
                    this.userContext = '';
                    this.currentSegment = null;
                    const modalEl = document.getElementById(this.modalId);
                    if (modalEl && window.bootstrap) {
                        const modal = window.bootstrap.Modal.getInstance(modalEl);
                        if (modal) modal.hide();
                    }
                })
                .catch((error) => {
                    this.$emit('error', error.response?.data?.message || 'Failed to submit. Please try again.');
                })
                .finally(() => {
                    this.submitting = false;
                });
        },
        handleClose() {
            this.userContext = '';
            this.currentSegment = null;
        },
    },
});
</script>
